import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import axiosInstance from '../../services/axios';
import TextArea from '../../components/form/TextArea';

export default function CallNotes({id,notes=[], onSuccess, onClose}) {
console.log("id in CallNotes:", notes); // Log the id to check if it's being passed correctly
  const [localNotes, setLocalNotes] = useState(notes);
  const [formData, setFormData] = useState({
    remarks: ''
  })
  
  // Update local notes when prop changes
  useEffect(() => {
    setLocalNotes(notes);
  }, [notes]);
    const [buttonLoading, setButtonLoading] = useState(false);
    const handleSubmit = async (e) => {
              e.preventDefault();
              let data = {
                id: id?.uuid || id, // Use the passed id
                remarks: formData.remarks,
              };
                setButtonLoading(true);
                try {
                let response;
                  response = await axiosInstance.post('/call-collections/details/notes', data);
    
                  if (response.data?.status === "success") {
                    let newNotes =  {
                    "callRemarks": formData.remarks,
                    "callRecording": null,
                    "createAt": new Date().toISOString(),
                    "employee": {
                        "name": JSON.parse(localStorage.getItem("user"))?.name,
                        "email": JSON.parse(localStorage.getItem("user"))?.email,
                        "profileImg": JSON.parse(localStorage.getItem("user"))?.profileImg,
                        "phone": JSON.parse(localStorage.getItem("user"))?.phone
                    }
                }
                // Update local state instead of mutating prop
                setLocalNotes(prevNotes => [newNotes, ...prevNotes]);
                  toast.success("Remarks created successfully!");
                  // Call the success callback if provided
                  if (onSuccess) {
                    onSuccess(id, formData.remarks);
                  }
                  // Call the close callback if provided
                  if (onClose) {
                    onClose();
                  }
                  setFormData({ remarks: '' }); // Reset form data after successful submission
                } else {
                  toast.error("Failed to create remarks");
                }
                 setButtonLoading(false);
              } catch (error) {
                 setButtonLoading(false);
                console.error("Error in creating remarks:", error); // Better error logging
                toast.error(error?.message ?? "Something went wrong");
              }
            }; 

  return (
    <>
    {
        localNotes.length > 0 &&
         <div className='my-3 max-h-[200px] h-[200px] overflow-auto'>
            {
                localNotes.map((item, index)=>(
                    <div key={item.id || index} className="p-2 mr-2 border-b bg-white rounded-lg mb-1">
                       <div className='flex justify-between'>
                         <small>{item.employee.email === JSON.parse(localStorage.getItem("user"))?.email ? "You" : item.employee.name}</small>
                         <small>{new Date(item.createAt).toLocaleString()}</small>
                       </div>
                        <p className="text-sm text-gray-700">{item.callRemarks}</p>
                    </div>
                ))
            }
        </div>
    }
     <form onSubmit={handleSubmit} className="space-y-4">
               <TextArea
               rows="10"
                 label="Remarks"
                 value={formData.remarks}
                 onChange={(e) =>
                   setFormData((prev) => ({ ...prev, remarks: e.target.value }))
                 }
                 required
               />
                    <button
                      type="submit"
                      className={`bg-primary-light w-full text-white px-3 py-2 rounded-xl ${buttonLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={buttonLoading}
                    >
                     Create
                    </button>
             </form>
    </>
  )
}
